import { supabaseClient } from '@/utils/supabase-client';

export const ingredientsApi = {
  /**
   * Get organisation ingredients from ingredient_overview
   */
  getOrganisationIngredients: (organisationId: string) => {
    return supabaseClient
      .from('ingredient_overview')
      .select('*')
      .eq('organisation_id', organisationId);
  },

  /**
   * Get ingredient by ID with related data
   */
  getIngredientById: (ingredientId: string, organisationId: string | null) => {
    let query = supabaseClient
      .from('ingredient_overview')
      .select('*, latest_ingredient_allergen(*), latest_ingredient_nutrient(*)')
      .eq('id', ingredientId);

    if (organisationId) {
      query = query.eq('organisation_id', organisationId);
    } else {
      query = query.is('organisation_id', null);
    }

    return query
      .order('created_at', {
        referencedTable: 'latest_ingredient_allergen',
        ascending: false,
      })
      .order('created_at', {
        referencedTable: 'latest_ingredient_nutrient',
        ascending: false,
      })
      .single();
  },

  getIngredientNutrients: (ingredientId: string) => {
    return supabaseClient
      .from('ingredient_nutrient')
      .select('*')
      .eq('ingredient_id', ingredientId)
      .order('created_at', { ascending: false });
  },

  getIngredientAllergens: (ingredientId: string) => {
    return supabaseClient
      .from('ingredient_allergen')
      .select('*')
      .eq('ingredient_id', ingredientId)
      .order('created_at', { ascending: false });
  },

  /**
   * Get ingredients for a supplier
   */
  getSupplierIngredients: (supplierId: string) => {
    return supabaseClient
      .from('ingredient_overview')
      .select('*')
      .eq('supplier_id', supplierId);
  },

  getManagedSupplierIngredientsInfiniteSearch: (
    tenantId: string,
    supplierId: string,
    searchQuery: string,
  ) => {
    let query = supabaseClient
      .from('ingredient')
      .select('*, supplier(*), ingredient_price(count)')
      .eq('ingredient_price.organisation_id', tenantId)
      .eq('supplier_id', supplierId)
      .is('organisation_id', null)
      .order('name');

    if (searchQuery.trim()) {
      query = query.or(
        `name.ilike.%${searchQuery}%,code.ilike.%${searchQuery}%`,
      );
    }

    return query;
  },

  /**
   * Get recipes that use a specific ingredient
   */
  getIngredientRecipes: (ingredientId: string, organisationId: string) => {
    return supabaseClient
      .from('recipe_ingredient')
      .select(
        `
        id,
        recipe_id,
        recipe!recipe_id(title),
        latest_recipe_ingredient_quantity(end_quantity, unit)
      `,
      )
      .eq('ingredient_id', ingredientId)
      .eq('organisation_id', organisationId)
      .not('recipe_id', 'is', null)
      .order('recipe(title)');
  },
} as const;
